module.exports = __webpack_public_path__ + "half-way-done-celebration.088ffb5.png";